import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import '@mui/material/styles';

function Contact() {


  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);
  const {t} = useTranslation() as { t: (key: string) => string };

  const form = useRef();

  const sendEmail = (e: any) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    /* Uncomment below if you want to enable the emailJS */

    if (name !== '' && email !== '' && message !== '') {
      var templateParams = {
        name: name,
        email: email,
        message: message
      };

      console.log(templateParams);
      emailjs.send('service_jzbgpbq', 'template_y4dygwj', templateParams, 'jF8DlkSnZkD5w9tro').then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
        },
        (error) => {
          console.log('FAILED...', error);
        },
      );
      setName('');
      setEmail('');
      setMessage('');
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>{t('contact')}</h1>
          <p>{t('projectDescription')}</p>
          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className='contact-form'
          >
            <div className='form-flex'>
              <TextField
                required
                id="outlined-required"
                label={t('contact')}
                placeholder={t('namePlaceholder')}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                error={nameError}
                helperText={nameError ? t('nameError') : ""}
              />
              <TextField
                required
                id="outlined-required"
                label={t('emailPhone')}
                placeholder={t('emailPhonePlaceholder')}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                error={emailError}
                helperText={emailError ? t('emailError')  : ""}
              />
            </div>
            <TextField
              required
              id="outlined-multiline-static"
              label={t('message')}
              placeholder={t('messagePlaceholder')}
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              error={messageError}
              helperText={messageError ? t('messageError') : ""}
            />
            <Button variant="contained" endIcon={<SendIcon />} onClick={sendEmail}>
            {t('send')}
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;